import React, { FC, useState } from "react";
import { Sidebar as NavigationBar } from 'primereact/sidebar';
import './sidebar.css';
import { AiOutlineFundView, AiOutlineHome } from 'react-icons/ai';
import { BsRocketTakeoff } from 'react-icons/bs';
import { BiError } from 'react-icons/bi';
import { RiAdminLine } from 'react-icons/ri';
import { Footer } from "./Footer/Footer";
import { MenuItem } from "./MenuItem/MenuItem";
import { Accordion, AccordionTab } from 'primereact/accordion';
import { RiArrowUpSLine, RiArrowDownSLine } from 'react-icons/ri';
import { MdOutlineFireplace } from 'react-icons/md';
import { SiFuturelearn } from 'react-icons/si';

export const Sidebar: FC<any> = (props): JSX.Element => {
    const { visible, setVisible, history, image } = props;

    const [activeIndex, setActiveIndex] = useState<number[]>([]);

    const handleVisualizacionEscenario = () => { history.push("/scenario_view/1/1"); setVisible(false); };
    const handleVisualizacionPlan = () => { history.push("/scenario_plan/1/1"); setVisible(false); };
    const handleLanzamientos = () => { history.push("/launches"); setVisible(false); };
    const handleHome = () => { history.push("/home"); setVisible(false); };
    const handleErrores = () => { history.push("/errors"); setVisible(false); };
    const handleAdmin = () => { history.push("/admin"); setVisible(false); };

    const openVisualizacion = (itemIndex: number) => {
        let _activeIndex: any = activeIndex ? [...activeIndex] : [];
        const index = _activeIndex.indexOf(itemIndex);
        if (index === -1) _activeIndex.push(itemIndex);
        else _activeIndex.splice(index, 1);
        setActiveIndex(_activeIndex);
    };

    const customIcons = (
        <React.Fragment>
            <img src={image} width={185} style={{ minHeight: 89 }} />
        </React.Fragment>
    );

    return (
        <div className="card flex justify-content-center">
            <NavigationBar visible={visible} onHide={() => setVisible(false)} icons={customIcons}>
                <MenuItem
                    redirect={handleHome}
                    classname={history.location.pathname.startsWith("/home") ? "menu-link-selected" : "menu-link"}
                    Component={<AiOutlineHome style={{ fontSize: 26, color: "currentColor" }} />}
                    title={"Menú Principal"}
                    visible={true}
                />

                <Accordion activeIndex={history.location.pathname.startsWith('/scenario') ? 0 : -1}>
                    <AccordionTab header={
                        <MenuItem
                            redirect={() => openVisualizacion(0)}
                            classname={history.location.pathname.startsWith('/scenario') ? "menu-link-selected" : "menu-link"}
                            Component={<AiOutlineFundView style={{ fontSize: 26, color: "currentColor" }} />}
                            Component2={activeIndex[0] === 0 ? <RiArrowUpSLine style={{ marginLeft: '0.5rem', color: "currentColor" }} size={20} /> : <RiArrowDownSLine style={{ marginLeft: '0.5rem', color: "currentColor" }} size={20} />}
                            title={`Visualización`}
                            visible={true}
                        />
                    }>
                        <MenuItem
                            redirect={handleVisualizacionEscenario}
                            classname={history.location.pathname.startsWith('/scenario_view') ? "menu-link-selected" : "menu-link"}
                            Component={<MdOutlineFireplace style={{ fontSize: 18, color: "currentColor" }} />}
                            title={"Escenario"}
                            visible={true}
                        />
                        <MenuItem
                            redirect={handleVisualizacionPlan}
                            classname={history.location.pathname.startsWith('/scenario_plan') ? "menu-link-selected" : "menu-link"}
                            Component={<SiFuturelearn style={{ fontSize: 18, color: "currentColor" }} />}
                            title={"Simulación"}
                            visible={true}
                        />
                    </AccordionTab>
                </Accordion>

                <MenuItem
                    redirect={handleLanzamientos}
                    classname={history.location.pathname === "/launches" ? "menu-link-selected" : "menu-link"}
                    Component={<BsRocketTakeoff style={{ fontSize: 26, color: "currentColor" }} />}
                    title={"Lanzamientos"}
                    visible={true}
                />
                <MenuItem
                    redirect={handleErrores}
                    classname={history.location.pathname === "/errors" ? "menu-link-selected" : "menu-link"}
                    Component={<BiError style={{ fontSize: 26, color: "currentColor" }} />}
                    title={"Errores Comunes"}
                    visible={true}
                />
                {/* <MenuItem
                    redirect={handleAdmin}
                    classname={history.location.pathname === "/admin" ? "menu-link-selected" : "menu-link"}
                    Component={<RiAdminLine style={{ fontSize: 26, color: "currentColor" }} />}
                    title={"Administración"}
                    visible={true}
                /> */}
                
                <Footer />
            </NavigationBar>
        </div>
    );
};
